import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["recipientSelect", "recipientIdField"];
  static values = {
    clientAdvisorId: String,
    assigneeId: String
  };

  connect() {
    // Set up select2 change handler if recipient select exists
    if (this.hasRecipientSelectTarget) {
      const $select = $(this.recipientSelectTarget);

      $select.on('select2:select', (e) => {
        this.recipientIdFieldTarget.value = e.params.data.id || "";
      });

      $select.on('select2:clear', () => {
        this.recipientIdFieldTarget.value = "";
      });
    }
  }

  // Called when recipient type changes - updates recipient_id for assignee/client_advisor
  typeChanged(event) {
    const selectedType = event.target.value;

    switch (selectedType) {
      case "assignee":
        this.recipientIdFieldTarget.value = this.assigneeIdValue || "";
        break;
      case "client_advisor":
        this.recipientIdFieldTarget.value = this.clientAdvisorIdValue || "";
        break;
      case "employee":
      case "customer":
        // Will be set by the select2 dropdown after form re-renders
        this.recipientIdFieldTarget.value = "";
        break;
      default:
        this.recipientIdFieldTarget.value = "";
    }
  }
}
